import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ToastsManager } from "@app/shared/util/toastr.service";

import { TableConfig } from '@app/shared/util/table-config.utils';


import { OperationTypeService } from "@services/operation-type.service";
import { OperationType } from "@app/tool/model/operationType.model";
import { Log } from "ng2-logger";
import { OperationTypesModalComponent } from "@app/roles/admin/pages/ticket-management/components/operation-types/components";
import { PermissionService } from "@app/authentication/services/permission.service";

@Component({
    selector: 'app-operation-types',
    templateUrl: './operation-types.component.html',
    styleUrls: ['./operation-types.component.scss']
})
export class OperationTypesComponent implements OnInit {
    _logger = Log.create(OperationTypesComponent.name);

    @ViewChild(OperationTypesModalComponent, {static: true}) operationTypesFormModal: OperationTypesModalComponent;

    operationTypes: OperationType[] = [];
    tableConfig = new TableConfig();
    isLoadingOperationTypes = false;

    constructor(private operationTypesService: OperationTypeService,
                private toastr: ToastsManager,
                private permissionService: PermissionService,
                private translationService: TranslateService) {
    }

    ngOnInit() {
        this.getOperationTypes(this.tableConfig);
    }


    onFilter(tableConfig: TableConfig) {
        this.getOperationTypes(tableConfig);
    }

    openOperationTypesModal() {
        this.operationTypesFormModal.open();
    }

    getOperationTypes(tableConfig = this.tableConfig) {
        this._logger.info('getOperationTypes:: Retrieving operation types ');
        this.isLoadingOperationTypes = true;
        this.operationTypesService.getAllOperationTypes(tableConfig).subscribe(data => {
                this._logger.info('getOperationTypes:: API responded with data', data);
                this.operationTypes = data.operationTypes;
                this.tableConfig.pager.count = data.count;
                this.isLoadingOperationTypes = false;
                this._logger.info('API responded with data', data);
            },
            (error: any) => {
                this.isLoadingOperationTypes = false;
                this._logger.info('getOperationTypes:: API responded with error', error);
            });
    }

    createOperationType(operationType) {
        this._logger.info('createOperationType:: Creating operation type ');
        this.isLoadingOperationTypes = true;
        this.operationTypesService.createOperationType(operationType).subscribe(
            (data: any) => {
                this._logger.info('createOperationType:: API responded with data', data);
                this.getOperationTypes();
                this.isLoadingOperationTypes = false;
                this.toastr.success(this.buildCreateMessage(data.name));
            },
            (error: any) => {
                this._logger.info('createOperationType:: API responded with error', error);
                this.isLoadingOperationTypes = false;
            }
        );
    }

    updateOperationType(operationTypeUpdate) {
        this._logger.info('updateOperationType:: Updating operation type', operationTypeUpdate);
        this.isLoadingOperationTypes = true;
        this.operationTypesService.updateOperationType(operationTypeUpdate.newOperationType).subscribe(
            (data: any) => {
                this._logger.info('updateOperationType:: API responded with data', data);
                this.getOperationTypes();
                this.isLoadingOperationTypes = false;
                this.toastr.success(this.buildUpdateMessage(operationTypeUpdate.previousOperationTypeName));
            },
            (error: any) => {
                this._logger.info('updateOperationType:: API responded with error', error);
                this.isLoadingOperationTypes = false;
            }
        );
    }

    deleteOperationType(operationType) {
        this._logger.info('deleteOperationType:: Deleting operation type', operationType);
        this.isLoadingOperationTypes = true;
        this.operationTypesService.deleteOperationType(operationType).subscribe(
            (data: any) => {
                this._logger.info('deleteOperationType:: API responded with error', data);
                this.getOperationTypes();
                this.isLoadingOperationTypes = false;
                this.toastr.warning(this.buildDeleteMessage(operationType.name));
            },
            (error: any) => {
                this._logger.info('deleteOperationType:: API responded with error', error);
                this.isLoadingOperationTypes = false;
            }
        );
    }

    buildCreateMessage(processTypeName) {
        return this.translationService.instant('admin.tickets.operation-types.toasts.created',
            {operationTypeName: processTypeName});
    }

    buildUpdateMessage(processTypeName) {
        return this.translationService.instant('admin.tickets.operation-types.toasts.updated',
            {operationTypeName: processTypeName});
    }

    buildDeleteMessage(processTypeName) {
        return this.translationService.instant('admin.tickets.operation-types.toasts.deleted',
            {operationTypeName: processTypeName});
    }

    onSortChange(tableState) {
        this.getOperationTypes(tableState);
    }

    onPageChange(tableState) {
        this.getOperationTypes(tableState);
    }

    onTableRowClick(operationType: OperationType) {
        this.operationTypesFormModal.open(operationType);
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_TOOLS');
    }
}
